import _ from 'underscore';
import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { StaticFormGroup } from '@bingads-webui-cc-react/layout';

import { ViewTaxFormPropTypes } from '../../shapes';
import { BaseViewTaxFormList, isConfirmedYes, isConfirmedNo } from '../../utils';
import {
  IsIVAOrVATTaxPayerTypeKey, IsIVAOrVATTaxPayerPositiveLabelKey, IsIVAOrVATTaxPayerNegativeLabelKey,
  IsWithholdingTaxExemptedTypeKey, IsWithholdingTaxExemptedPositiveLabelKey, IsWithholdingTaxExemptedNegativeLabelKey,
} from '../../constants';

const { CountryCode } = Constants;

export const CLViewTaxForm = ({
  i18n,
  data,
  filledData,
  taxSchema,
  vatStatus,
}) => (
  <div className="default-view-tax-form">
    <BaseViewTaxFormList
      i18n={i18n}
      uiObject={filledData}
      taxSchema={taxSchema}
      vatStatus={vatStatus}
      countryCode={CountryCode.CL}
    />
    {isConfirmedYes(_.result(data, IsIVAOrVATTaxPayerTypeKey)) && (
      <StaticFormGroup showLabel={false} id={`tax-info-${IsIVAOrVATTaxPayerTypeKey}`}>
        {i18n.getString(IsIVAOrVATTaxPayerPositiveLabelKey)}
      </StaticFormGroup>
    )}
    {isConfirmedNo(_.result(data, IsIVAOrVATTaxPayerTypeKey)) && (
    <StaticFormGroup showLabel={false} id={`tax-info-${IsIVAOrVATTaxPayerTypeKey}`}>
      {i18n.getString(IsIVAOrVATTaxPayerNegativeLabelKey)}
    </StaticFormGroup>
    )}
    {isConfirmedYes(_.result(data, IsWithholdingTaxExemptedTypeKey)) && (
    <StaticFormGroup showLabel={false} id={`tax-info-${IsWithholdingTaxExemptedTypeKey}`}>
      {i18n.getString(IsWithholdingTaxExemptedPositiveLabelKey)}
    </StaticFormGroup>
    )}
    {isConfirmedNo(_.result(data, IsWithholdingTaxExemptedTypeKey)) && (
    <StaticFormGroup showLabel={false} id={`tax-info-${IsWithholdingTaxExemptedTypeKey}`}>
      {i18n.getString(IsWithholdingTaxExemptedNegativeLabelKey)}
    </StaticFormGroup>
    )}

  </div>
);

CLViewTaxForm.propTypes = ViewTaxFormPropTypes;
